import React from 'react';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import { DesktopMessagesPanel } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/DesktopMessagesPanel';
import { MobileMessagesPanel } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MobileMessagesPanel';

const MessagesPanel = ({
  className,
}) => {
  const isMobile = useMobileLayout();
  const MessagesPanelComponent = isMobile ? MobileMessagesPanel : DesktopMessagesPanel;

  return (
    <MessagesPanelComponent className={className} />
  );
};

MessagesPanel.defaultProps = {
  className: '',
};

MessagesPanel.propTypes = {
  className: PropTypes.string,
};

export { MessagesPanel };
